import GlobeIconPath from "@ingka/ssr-icon/paths/globe";

export default GlobeIconPath;
